import {
  MAXIMUM_AMOUNT_AVAILABLE,
  SPECIFIC_AMOUNT,
  NONE,
  PRODUCT_TYPE_ROLLUP,
} from "lib/constants";

const filtersResolver = (loanInformation) => {
  if (
    !loanInformation ||
    loanInformation.loan_amount == null ||
    loanInformation.cash_reserve == null
  )
    return;

  const resolvedData = {
    initial_advance: {
      type: loanInformation.loan_amount_maximum
        ? MAXIMUM_AMOUNT_AVAILABLE
        : SPECIFIC_AMOUNT,
      value: loanInformation.loan_amount,
    },
    loan_details: {
      product_type: loanInformation.product_type,
    },
  };

  if (loanInformation.product_type === PRODUCT_TYPE_ROLLUP) {
    resolvedData.cash_reserve = {
      type: loanInformation.cash_reserve_maximum
        ? MAXIMUM_AMOUNT_AVAILABLE
        : loanInformation.cash_reserve === 0
        ? NONE
        : SPECIFIC_AMOUNT,
      value: loanInformation.cash_reserve,
    };
  }

  return resolvedData;
};

export default filtersResolver;
